import React, { useEffect, useState } from "react";
import CloudStorage from "../../../../../../../CloudStorage/CloudStorage";
import {
  getDateFormate,
  getRemaindays,
} from "../../../../../../Common/AllDateTimeReleventFormate";
import GetRemainDays from "./ProjectModels/GetRemainDays";
import { Modal } from "reactstrap";
import ModelContractPost from "../../../../../../Common/ContractandPost/ModelContractPost";
import ModelPostDetails from "../../../../../../Common/ContractandPost/ModelPostDetails";
import ProjectSubmitwork from "./ProjectModels/ProjectSubmitwork";
import ModelGiveReview from "../../../../../../Common/ContractandPost/ModelGiveReview";
import { useDispatch, useSelector } from "react-redux";
import { postsCancelByIdAPI } from "../../../../../../../redux/posts/action";
import ModelAcceptRejectPost from "../../../../../../Common/ContractandPost/ModelAcceptRejectPost";
import GetProjectStatus from "./ProjectModels/GetProjectStatus";
import ProjectApproveSubmission from "./ProjectModels/ProjectApproveSubmission";
import ProfilePic from "../../../../../../../assests/imgs/Profileplaceholder.svg";
import { cancelledredlabel, completedgreenlabel } from "../../../../../../Common/CommonLabels";
import ProfileImageWithFallback from "../../../../../../../common/ProfileImageWithFallback";
import ConfirmModal from "../../../../../../Common/ConfirmModal";
export default function MineActiveProjectOverview({
  setActiveTab,
  posts,
  proposalmilestones,
}) {
  const [acceptreject, setAcceptreject] = useState(false);
  const [viewPost, setviewPost] = useState(false);
  const [ASModel, setASModel] = useState(false);
  const [milestonedata, setmilestonedata] = useState("");
  const [contract, setContact] = useState(false);
  const [review, setReview] = useState(false);
  const [SWModel, setSWModel] = useState(false);
  const [index, setIndex] = useState("");
  const [confirmModal, setConfirmModal] = useState(false);
  const profile = useSelector(({ profile: { profiledata } }) => profiledata);

  const data = proposalmilestones?.milestones || [];
  const lengthofmilestone = data?.filter((milestone) =>
    ["1", "2", "3", "4", "5"].includes(milestone.status),
  )?.length;
  const countOfPaidAmount = data.filter(
    (milestone) => milestone.status == 5,
  ).length;

  const calculateStatus5Amount = (data) => {
    const milestonesStatus5 = data.filter(
      (milestone) => milestone.status == "5",
    );
    const count = milestonesStatus5.length;
    const totalPaidAmount = milestonesStatus5.reduce(
      (total, milestone) => total + parseFloat(milestone.amount),
      0,
    );
    return { count, totalPaidAmount };
  };
  const { count, totalPaidAmount } = calculateStatus5Amount(data);

  // const totalAmount = data.reduce((total, milestone) => total + parseFloat(milestone.amount), 0);
  const totalAmount =
    data
      ?.filter((milestone) =>
        ["1", "2", "3", "4", "5"].includes(milestone.status),
      )
      .reduce((acc, milestone) => acc + parseFloat(milestone.amount), 0) || 0;

  const activeMilestones = data.filter((milestone) =>
    ["2", "3", "4"].includes(milestone.status),
  );

  const lastMilestoneIndex = data
    .slice()
    .reverse()
    .findIndex((milestone) => ["2", "3", "4", "5"].includes(milestone.status));
  const lastMilestone = data[data.length - 1 - lastMilestoneIndex];

  let upcomingMilestones = [];

  if (lastMilestone) {
    const lastMilestoneIndex = data.findIndex(
      (milestone) => milestone == lastMilestone,
    );
    const nextMilestone = data[lastMilestoneIndex + 1];

    if (nextMilestone && nextMilestone.status == "1") {
      upcomingMilestones = [nextMilestone];
    }
  }
  const dispatch = useDispatch()
  const postsCancelBy = (value) => {
    const data = {
      "post_id": posts?.id, "type": "1", "status": value == 2 ? 2 : "4"
    }
    dispatch(postsCancelByIdAPI(data))
    setAcceptreject(false)
  }

  useEffect(() => {
    if (posts?.cancle_requested == 1 && posts?.is_mine == 1 && posts?.status != 3 && posts?.status != 4) {
      setAcceptreject(true)
    }
  }, [posts?.cancle_requested])

  const cancleit = (value) => {
    console.log(value, 'valuevaluevaluevalue');
    if (value == 1) {
      postsCancelBy(1)
    }
    else {
      postsCancelBy(2)
    }
  }
  return (
    <div className=" project-section project-details p-0">
      <div className="post-details col-md-12">
        <div className="row active-row">
          <div className="col-md-4 signup-back">
            <div className="signup-sec">
              <h4>Upcoming milestones</h4>
              <p>
                {upcomingMilestones[0]?.title
                  ? `${countOfPaidAmount + 2}. ${upcomingMilestones[0]?.title}`
                  : "No Upcoming milestones"}
              </p>
            </div>
          </div>
          <div className="col-md-4 signup-back">
            <div className="signup-sec">
              <h4>Milestones completed</h4>
              <p>
                {countOfPaidAmount} out of {lengthofmilestone}
              </p>
            </div>
          </div>
          <div className="col-md-4 signup-back">
            <div className="signup-sec">
              <h4>{posts?.is_mine == 1 ? "Amount Paid" : "Amount Received"}</h4>
              <p>
                $ {totalPaidAmount} of $ {totalAmount}.
              </p>
            </div>
          </div>
          {
            (posts?.status == 4 || posts?.status == 3) ? <></> :
              <div className="col-md-12">
                <div className="post-back" style={{ flexWrap: 'wrap', rowGap: '10px' }}>
                  <div className="col-lg-3 col-md-6">
                    <h3>Active milestone </h3>
                    <p>
                      {activeMilestones[0]?.title
                        ? `${countOfPaidAmount + 1}. ${activeMilestones[0]?.title}`
                        : "No Active milestones"}
                    </p>
                    {activeMilestones[0]?.title ? (
                      <GetRemainDays enddate={activeMilestones[0]?.ends_on} />
                    ) : (
                      ""
                    )}
                  </div>
                  <div className="activity col-lg-3 col-md-6">
                    <h3>Due on</h3>
                    <h6>
                      {activeMilestones[0]?.ends_on
                        ? getDateFormate(activeMilestones[0]?.ends_on)
                        : ""}
                    </h6>
                    <p>
                      {/* {activeMilestones[0]?.ends_on
                    ? "Status : Work in progress"
                    : "No Active milestones"} */}
                      <GetProjectStatus status={activeMilestones[0]?.status} />
                    </p>
                  </div>

                  {posts?.is_mine == 1 ? (
                    <div className=" col-lg-5 col-md-6 overview-center expert-overdue-center">
                      <span>About Expert </span>
                      <div className="expert-left d-flex expert-overdue align-items-start">
                        <ProfileImageWithFallback url={proposalmilestones?.profile_image} style={{ height: "80px", width: "80px" }} />
                        <div>
                          <h2>
                            {proposalmilestones?.first_name} &nbsp;
                            {proposalmilestones?.last_name}
                          </h2>
                          <h6 className="pt-2">{proposalmilestones?.designation} </h6>
                          <p>
                            <p>
                              <img
                                width={40}
                                src={`${CloudStorage.cloudurl}/Assets/Images/project/location.svg`}
                                alt=""
                              />
                              Location: {proposalmilestones?.working_country_title}
                            </p>
                          </p>
                          <p>
                            <i className="fa-solid fa-star" style={{ color: ' #08AF22', fontSize: '21px' }}></i>
                            {proposalmilestones?.expert_rating || 0} (
                            {proposalmilestones?.expert_comment_count || 0} reviews)
                          </p>
                          {/* <p>Location: {proposalmilestones.location}</p> */}
                        </div>
                      </div>

                    </div>
                  ) : (
                    <div className=" col-lg-5 col-md-6 overview-center expert-overdue-center">
                      <span>About the Client</span>
                      <div className="expert-left d-flex">
                        <ProfileImageWithFallback url={posts?.user?.profile_image} style={{ height: "80px", width: "80px" }} />
                        <div>
                          <h2>
                            {posts?.user?.first_name} {posts?.user?.last_name}
                          </h2>
                          <h6>{posts?.user?.designation} </h6>
                          <p>
                            <i className="fa-solid fa-star"></i>&nbsp;&nbsp;
                            {posts?.user?.rating} ({posts?.user?.reviews} reviews)
                          </p>
                          <p>
                            <img
                              width={40}
                              src={`${CloudStorage.cloudurl}/Assets/Images/project/location.svg`}
                              alt=""
                            />
                            Location: {posts?.user?.country}
                          </p>
                        </div>
                      </div>
                    </div>
                  )}

                  {posts?.is_mine == 1 ? (
                    <button onClick={() => setActiveTab("Milestones")} className="btn">
                      View milestone
                      <img
                        src={`${CloudStorage.cloudurl}/Assets/Images/homepage/right-arrow-orange.svg`}
                        alt=""
                      />
                    </button>
                  ) : (
                    <>
                      {activeMilestones[0]?.title ? (
                        <>
                          {
                            activeMilestones[0]?.status == 3 ? (
                              <button
                                onClick={() => {
                                  setSWModel(true);
                                  setmilestonedata(activeMilestones[0]);
                                  setIndex(index + 1);
                                }}
                                className="btn"
                              >
                                View Submission
                                <img
                                  src={`${CloudStorage.cloudurl}/Assets/Images/homepage/right-arrow-orange.svg`}
                                  alt=""
                                />
                              </button>
                            ) : (
                              <button
                                onClick={() => {
                                  setASModel(true);
                                  setmilestonedata(activeMilestones[0]);
                                }}
                                className="btn"
                              >
                                Submit work for payment
                                <img
                                  src={`${CloudStorage.cloudurl}/Assets/Images/homepage/right-arrow-orange.svg`}
                                  alt=""
                                />
                              </button>
                            )
                          }
                        </>
                      ) : (
                        ""
                      )}
                    </>
                  )}
                </div>
              </div>
          }

          <div className="col-md-12 post-contract">
            <a onClick={() => setviewPost((state) => !state)}>
              View post
              <img
                src={`${CloudStorage.cloudurl}Assets/Images/dashboard/square-arrow.svg`}
                alt=""
              />
            </a>
            <a onClick={() => setContact((state) => !state)}>
              View contract
              <img
                src={`${CloudStorage.cloudurl}Assets/Images/dashboard/square-arrow.svg`}
                alt=""
              />
            </a>
            <a onClick={() => posts?.status == 2 && setConfirmModal(true)}>
              {posts?.cancle_requested == 1 ? 'Cancel Requested' : posts?.status == 4 ? cancelledredlabel : posts?.status == 3 ? completedgreenlabel : 'Cancel'}
              {(posts?.status == 2 && posts?.cancle_requested != 1) && (
                <img src={`${CloudStorage.cloudurl}Assets/Images/dashboard/square-arrow.svg`} alt="" />
              )}
            </a>

            {posts?.status == 3 &&
              <>
                {
                  proposalmilestones?.post_rating > 0 ?
                    <a >
                      Already Reviewed
                    </a>
                    :
                    <a onClick={() => setReview((state) => !state)}>
                      Give Review
                      <img
                        src={`${CloudStorage.cloudurl}Assets/Images/dashboard/square-arrow.svg`}
                        alt=""
                      />
                    </a>
                }
              </>
            }
          </div>
        </div>
      </div>
      <Modal
        size="xl"
        className="popupmodal rent-modal"
        isOpen={acceptreject}
      // toggle={() => setAcceptreject((state) => !state)}
      >
        <ModelAcceptRejectPost setAcceptreject={setAcceptreject} posts={posts} cancleit={cancleit} />
      </Modal>

      <Modal
        isOpen={ASModel}
        keyboard={false}
        className="modal-centered popupmodal"
      // size="xl"
      >
        <ProjectSubmitwork
          milestonedata={milestonedata}
          setASModel={setASModel}
          index={countOfPaidAmount + 1}
        />
      </Modal>

      <Modal
        size="xl"
        className="popupmodal rent-modal"
        isOpen={viewPost}
        toggle={() => setviewPost((state) => !state)}
      >
        <ModelPostDetails setviewPost={setviewPost} posts={posts} proposalmilestones={proposalmilestones} />
      </Modal>
      <Modal
        size="xl"
        className="popupmodal rent-modal"
        isOpen={contract}
        toggle={() => setContact((state) => !state)}
      >
        <ModelContractPost
          setContact={setContact}
          proposalmilestones={proposalmilestones}
        />
      </Modal>
      <Modal
        size="xl"
        className="popupmodal rent-modal"
        isOpen={review}
        toggle={() => setReview((state) => !state)}
      >
        <ModelGiveReview
          setReview={setReview}
          proposalmilestones={proposalmilestones}
          posts={posts}
        />
      </Modal>
      <div
        isOpen={SWModel}
        keyboard={false}
        className={
          SWModel
            ? `modal viewsubmission-modal add-education-modal add-bxp-modal active`
            : "modal viewsubmission-modal add-education-modal add-bxp-modal"
        }
        id="viewsubmission"
      >
        <ProjectApproveSubmission
          index={index}
          posts={posts}
          milestonedata={milestonedata}
          setSWModel={setSWModel}
        />
        <ConfirmModal
          isOpen={confirmModal}
          toggle={() => setConfirmModal(false)}
          title="Confirm Cancellation"
          message={`Are you sure you want to cancel this post?`}
          confirmpopupmessage={
            `All pending milestones will be rejected, and payments for accepted milestones will be released.
            This action cannot be undone.
            As per admin configuration, each user is allowed a limited number of cancellations. 
            You have used ${profile?.settings?.total_cancelation || 0} out of ${profile?.settings?.max_cancelation || 0} allowed cancellations.`
          }
          onConfirm={() => postsCancelBy()}
          showConfirmModel={true}
        />
      </div>
    </div>
  );
}
